export function validPin(latitude, longitude) {
  return latitude != null && longitude != null && String(latitude).trim() !== '' && String(longitude).trim() !== '' &&
    Number.isFinite(Number(latitude)) && Number.isFinite(Number(longitude)) &&
    Math.abs(Number(latitude)) <= 90 && Math.abs(Number(longitude)) <= 180;
}

const COORDINATE_PAIR = /^\s*(?:loc:)?\s*(-?\d+(?:\.\d+)?)\s*,\s*\+?\s*(-?\d+(?:\.\d+)?)(?:,\d+(?:\.\d+)?[a-z])?\s*$/i;
const decodePart = value => { try { return decodeURIComponent(value.replace(/\+/g, ' ')); } catch { return value; } };

// Google Maps links carry coordinates in several places. Candidates are tried
// from most to least precise: a place's exact pin (!3d…!4d…), the q/query/ll
// parameters, a bare "lat,lng" path segment (WhatsApp's /maps/search/lat,lng),
// then the /@lat,lng viewport centre.
function googleUrlCandidates(url) {
  const path = decodePart(url.pathname);
  const exact = path.match(/!3d(-?\d+(?:\.\d+)?)!4d(-?\d+(?:\.\d+)?)/);
  const segments = path.split('/').filter(Boolean);
  return [
    exact && `${exact[1]},${exact[2]}`,
    ...['q', 'query', 'll', 'center', 'destination', 'daddr'].map(name => url.searchParams.get(name)),
    ...segments.filter(segment => !segment.startsWith('@')),
    ...segments.filter(segment => segment.startsWith('@')).map(segment => segment.slice(1)),
  ].filter(Boolean);
}

// What a location field's text is, before searching: a link (anything with an
// http(s) URL, e.g. WhatsApp's share text), a "lat, lng" pair, or null for a
// place name to search. It only classifies; parseLocationInput reads the pin.
export function locationTextKind(input) {
  const text = String(input || '').trim();
  if (!text) return null;
  if (/https?:\/\/\S+/i.test(text) || /^(www\.)?(maps\.app\.goo\.gl|goo\.gl|maps\.google\.|google\.[a-z.]+\/maps)/i.test(text)) return 'link';
  return COORDINATE_PAIR.test(text) ? 'coordinates' : null;
}

export function parseLocationInput(input) {
  const raw = String(input || '').trim();
  const link = raw.match(/https?:\/\/\S+/i)?.[0];
  let candidates = [raw];
  if (link || (/^[a-z][a-z0-9+.-]*:/i.test(raw) && !COORDINATE_PAIR.test(raw))) {
    try {
      const url = new URL(link || raw);
      if (!['http:', 'https:'].includes(url.protocol)) return { error: 'Invalid location link' };
      if (url.hostname === 'maps.app.goo.gl' || url.hostname === 'goo.gl') return { error: 'Open the link and copy the coordinates', shortLink: url.href };
      if (!/(^|\.)google\.[a-z.]+$/.test(url.hostname)) return { error: 'Use a Google Maps link or latitude, longitude' };
      candidates = googleUrlCandidates(url);
    } catch { return { error: 'Invalid location link' }; }
  }
  for (const candidate of candidates) {
    const match = candidate.match(COORDINATE_PAIR);
    if (match && validPin(match[1], match[2])) return { latitude: Number(match[1]), longitude: Number(match[2]) };
  }
  return { error: 'Enter valid latitude, longitude' };
}

export function addressTextChange(form, address) { return { ...form, address }; }

export function addressPinError(form) {
  if (form.delivery_mode !== 'own' || validPin(form.latitude, form.longitude)) return '';
  if (!form.no_pin_reason) return 'Own delivery needs a pin or a reason for saving without one.';
  if (form.no_pin_reason === 'other' && !form.no_pin_note?.trim()) return 'Explain why the address has no pin.';
  return '';
}
